<template>
	<j-card class="mb2">
		<j-accordion colorWhenClosed="bg0">
			<div slot="title" class="fs4 fw7">{{ $t("clauses") }}</div>
			<div slot="body">
				<j-card class="mb0">
					<clauses
						v-bind="componentProps"
						v-on="componentHandlers"
						:showButtons="showButtons"
						:showRemoveButton="showRemoveButton"
					></clauses>
				</j-card>
			</div>
		</j-accordion>
	</j-card>
</template>

<script>
import JCard from "@/components/JCard"
import JAccordion from "@/components/JAccordion"
import Clauses from "./Clauses"

export default {
	name: "SectionClauses",
	components: {
		JCard,
		JAccordion,
		Clauses
	},
	props: {
		componentProps: {
			type: Object
		},
		componentHandlers: {
			type: Object
		},
		showButtons: {
			type: Boolean,
			required: false,
			default: true
		},

		// Specific boolean for remove button, because we only need it in policy, not in endorsement
		showRemoveButton: {
			type: Boolean,
			required: false,
			default: false
		}
	},

	methods: {}
}
</script>
